/*@jsxRuntime automatic @jsxImportSource react*/
import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import GithubLogo from 'Docs/contribute/assets/github-logo.js';
import {Icon} from '@dnb/eufemia/src';
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a",
    strong: "strong"
  }, _provideComponents(), props.components);
  return _jsxs(_components.p, {
    children: ["You may also be interested in ", _jsx(_components.a, {
      href: "/uilib/releases",
      children: "details about releases"
    }), " and have a look at the ", _jsxs(_components.a, {
      href: "https://github.com/dnbexperience/eufemia/releases",
      children: [_jsx(Icon, {
        icon: GithubLogo,
        size: "default"
      }), _jsx(_components.strong, {
        children: "GitHub Releases"
      })]
    }), " for versioning of the ", _jsx(_components.a, {
      href: "/uilib/",
      children: "@dnb/eufemia"
    }), "."]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
